/**
 * Debug logger that is silent unless debug mode is enabled.
 */
export type Logger = {
  log: (...args: unknown[]) => void;
  warn: (...args: unknown[]) => void;
  error: (...args: unknown[]) => void;
};

export function createLogger(debug: boolean): Logger {
  const prefix = "[ProsPix]";
  const noop = () => {};
  if (!debug) {
    return { log: noop, warn: noop, error: noop };
  }
  return {
    log: (...args) => console.log(prefix, ...args),
    warn: (...args) => console.warn(prefix, ...args),
    error: (...args) => console.error(prefix, ...args),
  };
}
